import { value, values } from './maybe';
export function breadcrumb(url, links) {
    var itemListElement = links.map(function (_a, index) {
        var title = _a.title, link = _a.link;
        return ({
            '@type': 'ListItem',
            item: {
                '@id': "".concat(url).concat(link),
                name: title,
            },
            position: index + 1,
        });
    });
    var breadcrumb = {
        itemListElement: itemListElement,
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        description: 'Breadcrumbs list',
        name: 'Breadcrumbs',
    };
    return breadcrumb;
}
export function schemaOrgWebPage(siteUrl, language, defaultDescription, defaultTitle, buildTime, image) {
    var url = value(siteUrl, '');
    var inLanguage = value(language, '');
    var description = value(defaultDescription, '');
    var name = value(defaultTitle, '');
    return {
        // headline,
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        url: url,
        inLanguage: inLanguage,
        mainEntityOfPage: url,
        description: description,
        name: name,
        // author: {
        //   '@type': 'Person',
        //   name: author
        // },
        // copyrightHolder: {
        //   '@type': 'Person',
        //   name: author
        // },
        copyrightYear: '2019',
        // creator: {
        //   '@type': 'Person',
        //   name: author
        // },
        // publisher: {
        //   '@type': 'Person',
        //   name: author
        // },
        // datePublished: '2019-01-18T10:30:00+01:00',
        dateModified: buildTime,
        image: {
            '@type': 'ImageObject',
            url: image,
        },
    };
}
export function faqPage(askMaybe, contentsMaybe) {
    var ask = value(askMaybe, '');
    var contents = values(contentsMaybe);
    return {
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        name: '',
        mainEntity: {
            '@type': 'Question',
            name: ask,
            text: ask,
            answerCount: 1,
            acceptedAnswer: {
                '@type': 'Answer',
                text: contents
                    ? contents
                        .map(function (c) { return c && c.text; })
                        .filter(function (c) { return !!c; })
                        .join('\n')
                    : '',
            },
        },
    };
}
//# sourceMappingURL=ld.js.map